import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { AnalyticsService } from 'libs/shared/src/lib/services/analytics.service';
import { SendService } from '../../../services/send.service';
import { SharedService } from '../../../services/shared.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'blu-send',
  templateUrl: './send.component.html',
  styleUrls: ['./send.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [RouterLink, RouterOutlet, NgClass, RouterLinkActive],
})
export class SendComponent {
  steps = [
    {
      label: 'Conteúdo',
      icon: 'wysiwyg',
      routerLink: '/user/send/content',
    },
    {
      label: 'Contatos',
      icon: 'contacts',
      routerLink: '/user/send/recipients',
    },
    {
      label: 'Envio',
      icon: 'send',
      routerLink: '/user/send/trigger',
    },
  ];

  constructor(
    public sendService: SendService,
    public sharedService: SharedService,
    public router: Router,
    public analyticsService: AnalyticsService,
  ) {}
}
